// extracted by css-extract-rspack-plugin
export default {"list":"list-vOuSar"};